import React from "react"
import { VehicleServiceCarousel } from "components"
import { gtmMyMazda2ActionTypes } from "store/gtm-events"

const MyMazdaVehicleServiceCarouselBlock = props => (
  <VehicleServiceCarousel
    gtmOnCarouselButtonClick={createGtmAction.checkEmailRegister}
    {...props} />
)

const createGtmAction = {
  checkEmailRegister: ({ buttonText }) => ({
    gtmID: gtmMyMazda2ActionTypes.CAROUSEL_CLICK,
    gtmPayload: { buttonText }
  })
}

export default MyMazdaVehicleServiceCarouselBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/service/carousel.jsx